import {observable, action} from 'mobx';
import {message} from '@enos/dpl';
import axiosInstance from '~/utils/axiosInstance';
import localeText from '@locale';
import uris from '~/uris';

class OuSecurityStore {
  @observable loginProtectionOption = '';

  @action.bound
  setLoginProtectionOption(value: string): void {
    this.loginProtectionOption = value;
  }

  getSecurityMFA(): Promise<any> {
    const url = uris.getSecurityMFA();
    return axiosInstance.get(url).then((data): void => {
      this.setLoginProtectionOption((data as any).mfaType);
    });
  }

  setSecurityMFA(mfaType: string): Promise<any> {
    return axiosInstance
      .post(uris.setSecurityMFA(), {}, {
        params: {mfaType}
      })
      .then((): void => {
        message.success(localeText('OU_SECURITY.PRMTMSG_SEND_CODE_SUCCEED'));
      });
  }
}

export default new OuSecurityStore();
